import {Component, Input, OnInit} from '@angular/core';
import {LoaderService, ResponsiveService} from '@core/src/public-api';
import {PrescriptionService} from '@shared/services/prescription.service';
import * as moment from 'moment';

@Component({
  selector: 'si-pres-prescription-item',
  templateUrl: './pres-prescription-item.component.html',
  styleUrls: ['./pres-prescription-item.component.scss']
})
export class PresPrescriptionItemComponent implements OnInit {
  @Input() id: number;
  @Input() title: string;
  @Input() initDate: number;
  @Input() endDate: number;
  @Input() posology: string;
  @Input() instructions: string;
  isPast: boolean;
  isCurrent: boolean;
  isFuture: boolean;
  stateText: string;
  isDesktop: boolean;

  constructor(
    private loaderService: LoaderService,
    private prescriptionService: PrescriptionService,
    private responsiveService: ResponsiveService
  ) {
    this.setResponsiveLogic();
  }

  ngOnInit(): void {
    this.calculateMedicationState();
  }

  setResponsiveLogic(): void {
    this.isDesktop = this.responsiveService.isDesktop();
  }

  calculateMedicationState(): void {
    const startOfToday = moment().startOf('day').valueOf();
    const endOfToday = moment().endOf('day').valueOf();

    if (!this.endDate) {
      if (this.initDate > endOfToday) {
        this.isFuture = true;
        this.stateText = 'SI_NOT_STARTED_F';
      } else {
        this.isCurrent = true;
        this.stateText = 'SI_STARTED_F';
      }
    } else {
      if (this.endDate < startOfToday) {
        this.isPast = true;
        this.stateText = 'SI_FINISHED_F';
      } else if (this.initDate > endOfToday) {
        this.isFuture = true;
        this.stateText = 'SI_NOT_STARTED_F';
      } else {
        this.isCurrent = true;
        this.stateText = 'SI_STARTED_F';
      }
    }
  }

  onClickDownloadPatientInformationSheet(): void {
    event.stopPropagation();
    event.preventDefault();
    this.isDesktop ? this.getOpenPatientInformationSheet() : this.getDownloadPatientInformationSheet();
  }

  async getOpenPatientInformationSheet(): Promise<void> {
    this.loaderService.start();
    try {
      await this.prescriptionService.getOpenPatientInformationSheet(this.id);
    } finally {
      this.loaderService.stop();
    }
  }

  async getDownloadPatientInformationSheet(): Promise<void> {
    this.loaderService.start();
    try {
      await this.prescriptionService.getDownloadPatientInformationSheet(this.id);
    } finally {
      this.loaderService.stop();
    }
  }
}
